import React, { useState, useEffect, forwardRef } from "react";
import ReactQuill from "react-quill-new";
import { formats, modules } from "utils";


type TextAreaCusProps = {
    value?: string;
    onChange?: (content: string) => void;
    className?: string;
    placeholder?: string;
    style?: React.CSSProperties;
}

export const TextAreaCus = forwardRef<ReactQuill, TextAreaCusProps>(
    ({ value = "", onChange, className, placeholder, style }, ref) => {
        const [editorValue, setEditorValue] = useState(value);

        useEffect(() => {
            setEditorValue(value || "");
        }, [value]);

        return (
            <div className="d-flex flex-1 ">
                <ReactQuill
                    ref={ref}
                    // theme="snow"
                    value={editorValue}
                    onChange={(content) => {
                        setEditorValue(content);
                        onChange?.(content);
                    }}
                    modules={modules}
                    formats={formats}
                    className={`${className}`}
                    style={style || {}}
                    placeholder={placeholder}
                />
            </div>
        );
    }
);